/**
 * ScrollToTop — isolated, non-visual route-change scroll reset.
 *
 * Place inside <BrowserRouter>. On every pathname change (and on the search
 * portion of the URL changing), it resets window.scrollTo(0, 0).
 *
 * In-page anchor jumps (URLs with a #hash) are preserved — we only reset
 * to top when there is no hash, so existing anchor scroll behavior like
 * `<a href="#tabs">` on /foundation continues to work.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let in-page anchors handle their own positioning
    // Use the Lenis instance when available (smooth-scroll engine in use)
    // so we don't fight the scroll engine; fall back to window.scrollTo.
    const lenis = window.__lenis;
    if (lenis && typeof lenis.scrollTo === "function") {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
